import {
  DOWNLOAD_COUNTRY_CONFIGURATION,
  SET_CJ_MAP_DISPLAY_MODE,
  SET_CJ_MAP_REGION,
  SET_CJ_ROLLOUT_APPLICATION_FILTER_EFFECT,
  TOGGLE_CJ_ROLLOUT_STATUS_FILTER,
} from "../../../actions";

import { THEME } from "../../../components/migration-wrappers";

const downloadCountryConfiguration = (payload) => ({
  type: DOWNLOAD_COUNTRY_CONFIGURATION,
  payload,
});

export const downloadCountryConfigurationEffect =
  (element, country) =>
  (dispatch, _, { window, getHtml2Canvas }) => {
    dispatch(downloadCountryConfiguration(country));

    getHtml2Canvas().then((html2canvas) =>
      html2canvas(element, {
        scrollX: 0,
        scrollY: -window.scrollY,
        onclone: (clonedDocument) => {
          const svgElements = clonedDocument.querySelectorAll("svg");
          const divElements = clonedDocument.querySelectorAll("div");

          // Adjusting SVGs before copying
          svgElements.forEach((item) => {
            item.setAttribute("width", item.getBoundingClientRect().width);
            item.setAttribute("height", item.getBoundingClientRect().height);
          });

          // Adjusting DIVs before copying
          divElements.forEach((item) => {
            if (item.classList.contains("card-container")) {
              item.style.boxShadow = "none";

              item.style.border = `1px solid ${THEME.getGrayColor(400)}`;
            }
          });
        },
      }).then((canvas) => {
        const dataURL = canvas.toDataURL("image/png");

        const date = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const anchor = document.createElement("a");
        anchor.href = dataURL;
        anchor.download = `FS-Config-${country}-${day}.${month}.${year}.png`;

        anchor.click();
      })
    );
  };

export const setCJMapDisplayMode = (payload) => ({
  type: SET_CJ_MAP_DISPLAY_MODE,
  payload,
});

export const setCJMapRegion = (payload) => ({
  type: SET_CJ_MAP_REGION,
  payload,
});

export const setCJRolloutApplicationFilterEffect = () => (dispatch) => {
  dispatch({ type: SET_CJ_ROLLOUT_APPLICATION_FILTER_EFFECT });
};

export const toggleCJRolloutStatusFilter = (payload) => ({
  payload,
  type: TOGGLE_CJ_ROLLOUT_STATUS_FILTER,
});
